export const TABLE_ROWS_KEY = 'teacherAnalysisSummaryTableRows';
export const TABLE_ROWS_NAMES = {
    variantsSolved: 'Решено вариантов',
    tasksSolved: 'Решено заданий',
    averageSolveAmount: 'Решено в среднем',
    errors: 'Средний % ошибок',
    solveAmount: 'Кол-во решавших',
    successStudents: 'Успешных учеников',
    earned: 'Заработано',
    extra_exercises: 'Доп. задание'
};
export const TABLE_ROWS_KEYS = Object.keys(TABLE_ROWS_NAMES);
export const DEFAULT_TABLE_ROWS = ['tasksSolved', 'errors', 'successStudents'];
